import React from "react";
import { notification } from "antd";
import type { ArgsProps } from 'antd/es/notification/interface';

interface NotiContextType {
    pushNoti: ({ message, type, description }: ArgsProps) => void
}

export const NotiContext = React.createContext<NotiContextType | null>(null);

export default function NotiProvider({ children }: { children: React.ReactNode }) {
    const [api, contextHolder] = notification.useNotification();

    const pushNoti = ({ message, type, description, ...restArgs }: ArgsProps) => {
        api[type || 'info']({
            message,
            description,
            placement: 'top',
            ...restArgs
        })
    }

    const contextValue = { pushNoti }
    return (
        <NotiContext.Provider value={contextValue}>
            {contextHolder}
            {children}
        </NotiContext.Provider>
    )
}